import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'referral-request-page',
  templateUrl: './referral-request-page.component.html',
  styleUrls: ['./referral-request-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferralRequestPageComponent {
  /** The referral credit is fixed: never taken from the URL. */
  readonly amount = 200;

  referrerName: string;
  origin: string | null;
  destination: string | null;
  date: string | null;
  cabin: string | null;
  passengers: number;

  /**
   * Shown after a referred visitor sends a trip request. The query parameters describe that request;
   * without them the page stays generic (no made-up name or trip).
   */
  constructor(private activatedRoute: ActivatedRoute) {
    const params = this.activatedRoute.snapshot.queryParamMap;

    this.referrerName = params.get('referrer')?.trim() || 'your friend';
    this.origin = params.get('origin');
    this.destination = params.get('destination');
    this.date = params.get('date');
    this.cabin = params.get('cabin');
    this.passengers = Number(params.get('passengers')) || 0;
  }

  get hasTrip() {
    return Boolean(this.origin && this.destination);
  }

  get tripMeta() {
    const passengers = this.passengers
      ? this.passengers === 1
        ? '1 passenger'
        : `${this.passengers} passengers`
      : null;

    return [this.date, this.cabin, passengers].filter(Boolean).join(' · ');
  }
}
